export const BaseUrl = 'https://cute-teal-piranha-kit.cyclic.app'
